module.exports = __webpack_public_path__ + "media/images/e-bilet/user-e5bc9404035b523424aabff74cdc68de.svg";